import { render } from 'storyblok-rich-text-react-renderer-ts';

import { RichTextStoryblok } from '../types/generated-storyblok';
import { RichTextLink } from './RichTextLink';

interface ContentBlockTextProps {
  blok: RichTextStoryblok;
}

export const ContentBlockText = ({ blok }: ContentBlockTextProps) => (
  <div className="aa-prose">
    {render(blok.richText, {
      markResolvers: {
        link: RichTextLink,
      },
    })}
  </div>
);
